import { cva } from 'class-variance-authority';

import s from './MessageItem.module.css';

export const messageItemVariants = cva(s.card, {
  defaultVariants: {
    sender: 'received',
    sending: false,
  },
  variants: {
    sender: {
      received: s.cardReceived,
      sent: s.cardSent,
    },
    sending: {
      false: null,
      true: s.cardSending,
    },
  },
});
